import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'

const EmailConfirmation: React.FC = () => {

  const handleResendVerification = async () => {
    console.log('resend verification')
  }

  return (
    <div className='flex h-screen w-screen flex-col md:flex-row'>
      <div className='relative hidden flex-1 md:block'>
        <img
          src='/images/auth-background.svg'
          alt='Auth background'
          className='absolute w-1/2 object-cover md:h-full md:w-5/6'
        />
        <div className='flex h-full items-center justify-center'>
          <img
            src='/images/auth-avatar.svg'
            alt='Auth Avatar'
            className='absolute z-10 object-contain md:h-full md:w-auto'
          />
        </div>
      </div>
      <div className='flex flex-1 flex-col items-center justify-center'>
        <div className='flex justify-center'>
          <img
            src='/images/oge.svg'
            alt='Huble logo'
            className='w-1/2 object-contain md:w-full'
          />
        </div>
        <div className='flex w-3/4 flex-col items-center md:w-full'>
          <Card className='w-full max-w-md border-none shadow-none'>
            <CardHeader className='space-y-1 flex flex-col items-center'>
              <CardTitle className='text-4xl font-bold leading-[50px]'>
                Email Confirmation
              </CardTitle>
              <CardDescription className='text-base text-black font-normal text-center'>
                An email has been sent to your mail. Please check your inbox to
                confirm.
              </CardDescription>
            </CardHeader>
            <CardContent className='space-y-4'>
              <Button
                onClick={handleResendVerification}
                className='w-full h-[38px] text-base font-normal bg-dark-blue hover:bg-dark-blue-hovered'
              >
                Resend Email
              </Button>
              <p className='text-center text-sm text-gray-700 mt-2'>
                Verified?{' '}
                <Link
                  to='/login'
                  className='text-dark-blue hover:underline font-medium'
                >
                  Go to Login
                </Link>
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default EmailConfirmation
